export const PageFeatureFlags = {
  ShowCanadaPostBanner: 'show-canada-post-banner',
  EnablePageViewTracking: 'mkt.enable-page-view-tracking',
  ShowGroceryContestBanner: 'show-grocery-contest-banner',
} as const;
